import { apiClient } from './client';
import { createCrudApi } from './crud';
import type { ApiSuccess } from '../types';

export interface UserRegion { id: number; name: string; states: string[] }
export interface User {
  id: number;
  email: string;
  fullName: string;
  mobile: string | null;
  status: 'active' | 'inactive' | 'locked';
  regionId: number | null;
  regionIds: number[];
  regions: UserRegion[];
  linkedEntityType: string | null;
  linkedEntityId: number | null;
  lastLoginAt: string | null;
  roleIds: number[];
  createdAt: string;
}

export interface CreateUserInput {
  email: string;
  fullName: string;
  mobile?: string;
  status?: 'active' | 'inactive' | 'locked';
  regionId?: number | null;
  regionIds?: number[];
  roleIds: number[];
  linkedEntityType?: string | null;
  linkedEntityId?: number | null;
  /** Optional manual password on create; omit to auto-generate a temporary one. */
  password?: string;
}

const base = createCrudApi<User, CreateUserInput>('users');

export const usersApi = {
  ...base,
  async create(input: CreateUserInput): Promise<User & { temporaryPassword: string }> {
    const { data } = await apiClient.post<ApiSuccess<User & { temporaryPassword: string }>>('/users', input);
    return data.data;
  },
  async setStatus(id: number, status: string): Promise<User> {
    const { data } = await apiClient.put<ApiSuccess<User>>(`/users/${id}/status`, { status });
    return data.data;
  },
  async resetPassword(id: number): Promise<{ temporaryPassword: string }> {
    const { data } = await apiClient.post<ApiSuccess<{ temporaryPassword: string }>>(
      `/users/${id}/reset-password`,
      {},
    );
    return data.data;
  },
};
